export default "__VITE_ASSET__ezUUOzbg__"